'use strict';

const _each = require('lodash/each');
const _merge = require('lodash/merge');
const _flatten = require('lodash/flatten');

const isInViewport = require('../../modules/helpers/isInViewport');
const ajax = require('../../modules/ajax');
const pushDataLayerEvent = require('../../modules/helpers/analyticsHelper');
const getCookie = require('./../util/getCookie');

// global variables
const autocomplete = [];
let storeLocatorAutoComplete, storeLocatorListener;
const ritualsFormHelper = require('../../rituals-form-helper');

// Google Places API
const places = {
    initStoreList: function (countryCode, triggerStoreAddressUpdate) {
        const element = $('.js-check-store-name-textfield');
        //Remove previous autocomplete listeners
        if (storeLocatorListener) {
            google.maps.event.removeListener(storeLocatorListener);
            storeLocatorListener = null;
        }
        if (storeLocatorAutoComplete) {
            google.maps.event.clearInstanceListeners(storeLocatorAutoComplete);
            storeLocatorAutoComplete = null;
        }
        $('.pac-container').remove();

        storeLocatorAutoComplete = new google.maps.places.Autocomplete(element[0], {
            componentRestrictions: {
                country: countryCode
            }
        });

        storeLocatorListener = storeLocatorAutoComplete.addListener('place_changed', triggerStoreAddressUpdate);
    },

    initStockFlyout: function (triggerStockAddressUpdate) {
        const autoCompleteElement = $('.js-check-instore-availabilty-zipcode-textfield');
        if (autoCompleteElement.length > 0) {
            autoCompleteElement.each(function (index, element) {
                if (typeof google === 'object' && typeof google.maps === 'object') {
                    const autocompleteField = new google.maps.places.Autocomplete(
                        element, {
                        componentRestrictions: {
                            country: $('.js-country_select').val() //find country in the footer from locale selector
                        }
                    }
                    );
                    // When the user selects an address from the dropdown, populate the address
                    // fields in the form.
                    autocompleteField.addListener('place_changed', triggerStockAddressUpdate);
                }
            });

            // prevent submitting the form when we select an address with enter key
            autoCompleteElement.keydown(function (e) {
                if (e.keyCode == 13) {
                    e.preventDefault();
                }
            });
        }

    },

    init: function () {
        places.clearPacInstances();

        // Create the autocomplete object, restricting the search to geographical
        // location types.
        const autoCompleteElement = $('[id$=_addressSearch].addressSearch');
        autoCompleteElement.each(function (index, element) {
            autocomplete[index] = new google.maps.places.Autocomplete(
                element, {
                types: [
                    'address'
                ],
                componentRestrictions: {
                    country: places.findRelatedCountryList($(element).closest('fieldset').find('[id$=country]').val())
                }
            }
            );

            autocomplete[index].fieldSet = $(element).closest('fieldset');

            // When the user selects an address from the dropdown, populate the address
            // fields in the form.
            autocomplete[index].addListener('place_changed', places.fillInAddress);
        });

        // prevent submitting the form when we select an address with enter key
        autoCompleteElement.keydown(function (e) {
            if (e.keyCode == 13) {
                e.preventDefault();
            }
        });

        // position the Google Places autocomplete dropdown under the input field in ROPO
        const $instoreAddressInput = $('.js-check-instore-availabilty-zipcode-textfield');
        $instoreAddressInput.on('focus', places.onFocusPacElement);

        // position the Google Places autocomplete dropdown under the input field in Account address list
        const $accountAddressInput = $('.js-account-address-list .inputfield-text.addressSearch');
        $accountAddressInput.on('focus', places.onFocusPacElement);

        //position the Google Places autocomplete dropdown under the input field in Change billing address flyout
        const $accountAddressFormWrapper = $('.js-flyout-content .js-billing-form .inputfield-text.addressSearch');
        $accountAddressFormWrapper.on('focus', places.onFocusPacElement);

        // position the Google Places autocomplete dropdown under the input field in the flyout on step 2 of checkout
        const $shippingAddressFlyoutInput = $('.js-flyout-content .js-shipping_address_form .inputfield-text.addressSearch');
        $shippingAddressFlyoutInput.on('focus', places.onFocusPacElement);

        // position the Google Places autocomplete dropdown under the input field on step 1 of checkout
        const $shippingAddressInput = $('.js-step-1-content .js-checkout-form [id$=_addressSearch]');
        $shippingAddressInput.on('focus', places.onFocusPacElement);

        // correct Google Places autocomplete dropdown position when scrolling in flyout
        $('.stores-flyout-content').scroll(function () {
            const $autoCompleteElement = $('.js-check-instore-availabilty-zipcode-textfield');
            const $placesSuggestionsContainer = $('.pac-container');
            //Set new top to autocomplete dropdown
            const newTop = $autoCompleteElement.offset().top + $autoCompleteElement.outerHeight();
            $placesSuggestionsContainer.css('top', newTop + 'px');
        });

        if (!$('.pac-container').hasClass('places-autocomplete')) {
            autoCompleteElement.on('focus', function () {
                $('.pac-container').addClass('places-autocomplete');
            });
        }
    },

    clearPacInstances: function () {
        _each(autocomplete, function (element) {
            google.maps.event.clearInstanceListeners(element);
        });

        $('.pac-container').remove();
    },

    onFocusPacElement: function () {
        const pacContainer = $('.pac-container');
        $(this).parent().append(pacContainer);
    },

    fillInAddress: function () {
        const place = this.getPlace();
        const currentFieldsetElement = this.fieldSet;

        //DL-28059 - Reversed the order of address components because the postalCode should be filled
        //before the state(postalCode needed for state validation)
        place.address_components.reverse();
        if (place && currentFieldsetElement) {
            // Clear the address fields
            places.clearAutocompleteAddressFields(currentFieldsetElement);
            const currentCountry = currentFieldsetElement.find('[id$=country]')[0].value.toLowerCase();
            let address1 = ' ';

            // Get each component of the address from the place details
            // and fill the corresponding field on the form.
            for (let i = 0; i < place.address_components.length; i++) {
                const addressType = place.address_components[i].types[0];
                const stateSelectorforCountries = ['US', 'IE'];
                const stateAttributeName = currentCountry == 'us' ? 'stateUS' : 'state';

                switch (addressType) {
                    case 'postal_town':
                    case 'locality':
                        currentFieldsetElement.find('[id$=city]').val(place.address_components[i].long_name).valid();
                        // trigger change for floating labels
                        currentFieldsetElement.find('[id$=city]').trigger('change');
                        break;

                    case 'street_number':
                        if (currentFieldsetElement.find('[id$=houseNumber]').length > 0) {
                            currentFieldsetElement.find('[id$=houseNumber]').val(place.address_components[i].long_name).valid();
                            // trigger change for floating labels
                            currentFieldsetElement.find('[id$=houseNumber]').trigger('change');
                        } else {
                            address1 = place.address_components[i].long_name + address1;
                        }
                        break;

                    case 'route':
                        if (currentFieldsetElement.find('[id$=street]').length > 0) {
                            currentFieldsetElement.find('[id$=street]').val(place.address_components[i].long_name).valid();
                            // trigger change for floating labels
                            currentFieldsetElement.find('[id$=street]').trigger('change');
                        } else {
                            address1 = address1 + place.address_components[i].long_name;
                        }
                        break;

                    case 'postal_code':
                        currentFieldsetElement.find('[id$=postal]').val(place.address_components[i].long_name).trigger('input');
                        $(document).trigger('shippingPostalCode.updated', [currentFieldsetElement.find('[id$=postal]')]);
                        break;

                    case 'administrative_area_level_1':
                        if (stateSelectorforCountries.indexOf(currentCountry.toUpperCase()) < 0) {
                            break;
                        }

                        currentFieldsetElement.find('[id$=postal]').data('state-id', place.address_components[i].short_name.toUpperCase());
                        // trigger change for floating labels
                        currentFieldsetElement.find('[id$=postal]').trigger('change');

                        currentFieldsetElement.find('[id$=' + stateAttributeName + ']').val(place.address_components[i].short_name.toUpperCase()).valid();
                        // trigger change for floating labels
                        currentFieldsetElement.find('[id$=' + stateAttributeName + ']').trigger('change').selectric('refresh');

                        break;
                    default:
                        break;
                }
            }

            if (address1.length > 0) {
                if (currentFieldsetElement.find('[id$=address1]').length > 0) {
                    currentFieldsetElement.find('[id$=address1]').val(address1).valid();
                    // trigger change for floating labels
                    currentFieldsetElement.find('[id$=address1]').trigger('change');
                } else if (currentFieldsetElement.find('[id$=street]').length > 0) {
                    currentFieldsetElement.find('[id$=street]').val(currentFieldsetElement.find('[id$=street]').val() + ' ' + address1).valid();
                    // trigger change for floating labels
                    currentFieldsetElement.find('[id$=street]').trigger('change');
                }
            }

            ritualsFormHelper.init();
        }
    },

    searchPlace: function (searchQuery, triggerAddressSearched) {
        //Get location from SearchText
        const request = {
            'address': searchQuery
        };

        const service = new google.maps.Geocoder();
        service.geocode(request, triggerAddressSearched);
    },

    getCurrentLocation: function (getCurrentLocationcompletion) {
        //Get Current location
        if (navigator && navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                places.getLocationFromLatLong(position.coords.latitude, position.coords.longitude, getCurrentLocationcompletion);
            }, function () {
                //Location access denied
                getCurrentLocationcompletion(null, null, null);
            });
        } else {
            //HTML5 Geolocation is not supperted
            getCurrentLocationcompletion(null, null, null);
        }
    },

    getLocationFromLatLong: function (latitude, longitude, getLocationCompletion) {
        if (latitude && longitude) {
            //Get location from Lat,Long
            if (typeof google === 'object' && typeof google.maps === 'object') {
                const geocoder = new google.maps.Geocoder();
                const geolocate = new google.maps.LatLng(latitude, longitude);
                geocoder.geocode({
                    'latLng': geolocate
                }, function (results, status) {
                    if (status == 'OK') {
                        getLocationCompletion(results, latitude, longitude);
                    } else {
                        //Something is wrong
                        getLocationCompletion(null, null, null);
                    }
                });
            }
        } else {
            //Something is wrong
            getLocationCompletion(null, null, null);
        }
    },

    getLatLongFromPostalCode: function (postalCode, country, getCoordinatesCallback) {
        if (!postalCode) {
            return;
        }
        const geocoder = new google.maps.Geocoder();

        const geocoderRequest = {
            componentRestrictions: {
                country: country.toLowerCase()
            },
            address: postalCode.replace(/ /g, '+') + ',+' + country
        };

        if (postalCode.match(/^\d+$/)) {
            geocoderRequest.componentRestrictions.postalCode = postalCode;
        }

        geocoder.geocode(geocoderRequest, function (results, status) {
            if (status === 'OK') {
                const location = results[0].geometry.location;
                getCoordinatesCallback(location.lat(), location.lng());
            } else {
                getCoordinatesCallback(null, null);
            }
        });
    },

    getStateFromPostalCode: function (postalCode, country, setStateCallback) {
        if (postalCode) {
            const geocoder = new google.maps.Geocoder();
            geocoder.geocode({
                componentRestrictions: {
                    postalCode: postalCode,
                    country: country
                }
            }, function (results, status) {
                let state = null;

                if (status === 'OK') {
                    const addressComponents = results[0]['address_components'];
                    for (let i = 0; i < addressComponents.length; i++) {
                        const addressType = addressComponents[i].types[0];

                        if (addressType === 'administrative_area_level_1') {
                            state = addressComponents[i].short_name.toUpperCase();
                        }
                    }
                }

                if (setStateCallback !== undefined && $.isFunction(setStateCallback)) {
                    setStateCallback(state);
                }
            });
        } else {
            if (setStateCallback !== undefined && $.isFunction(setStateCallback)) {
                setStateCallback(null);
            }
        }
    },

    compareStateToPostalCode: function (postalCode, country, state, setIsValidCallback) {
        if (postalCode) {
            new google.maps.Geocoder().geocode({
                componentRestrictions: {
                    postalCode: postalCode,
                    country: country
                }
            }, function (results, status) {
                let valid = false;

                if (status === 'OK') {
                    const addressComponents = results[0]['address_components'];
                    for (let i = 0; i < addressComponents.length; i++) {
                        const addressType = addressComponents[i].types[0];

                        if (addressType === 'administrative_area_level_1') {
                            if (addressComponents[i].long_name.toUpperCase() === state.toUpperCase()
                                || addressComponents[i].short_name.toUpperCase() === state.toUpperCase()) {
                                valid = true;
                            }
                        }
                    }
                }
                if (setIsValidCallback !== undefined && $.isFunction(setIsValidCallback)) {
                    setIsValidCallback(valid);
                }
            });
        } else {
            if (setIsValidCallback !== undefined && $.isFunction(setIsValidCallback)) {
                setIsValidCallback(false);
            }
        }
    },

    setStateFromPostalCode: function (e) {
        if (e.type == 'blur' || e.keyCode == 13) {
            const $postal = $(e.target);
            $postal.data('state-id', '');
            const postalCode = $postal.val();
            const country = $postal.closest('fieldset').find('[id$=_country]').val();
            const $stateUS = $postal.closest('fieldset').find('[id$=_stateUS]');

            places.getStateFromPostalCode(postalCode, country, function (state) {
                const optionIndex = $stateUS.find('option').filter(function () { return $(this).val() === state; }).index();
                $stateUS.prop('selectedIndex', optionIndex).selectric('refresh');
                $postal.data('state-id', state);
                $postal.data('changed', false);
                $stateUS.valid();
            });
        }
    },

    setStateIDDataForPostalCode: function () {
        const $postals = $('[id$=_postal]');

        $postals.each(function () {
            const $postal = $(this);
            $postal.data('state-id', '');

            const postalCode = $postal.val();
            const country = $postal.closest('fieldset').find('[id$=_country]').val();

            places.getStateFromPostalCode(postalCode, country, function (state) {
                $postal.data('state-id', state);
            });
        });
    },

    getReadableAddress: function (results) {
        let fallBackAddress = '';
        for (let indexResult = 0; indexResult < results.length; indexResult++) {
            const result = results[indexResult];
            for (let indexAddressComponent = 0; indexAddressComponent < result.address_components.length; indexAddressComponent++) {
                const addressComponent = result.address_components[indexAddressComponent];
                if (addressComponent.types.indexOf('administrative_area_level_2') != -1) {
                    return result.formatted_address;
                } else if (addressComponent.types.indexOf('administrative_area_level_1') != -1) {
                    fallBackAddress = result.formatted_address;
                }
            }
        }
        return fallBackAddress;
    },

    clearAutocompleteAddressFields: function (currentFieldsetElement) {
        if (currentFieldsetElement) {
            // Clear the address fields
            currentFieldsetElement.find('[id$=city]').val('');
            currentFieldsetElement.find('[id$=houseNumber]').val('');
            currentFieldsetElement.find('[id$=street]').val('');
            currentFieldsetElement.find('[id$=postal]').val('');
            currentFieldsetElement.find('[id$=state]').val('');
        }
    },

    findRelatedCountryList: function (countryCode) {
        switch (countryCode.toUpperCase()) {
            case 'FR':
                return ['FR', 'MC'];
            default:
                return countryCode;
        }
    },
};

// Google Maps API
const maps = {
    config: {},

    init: function (el, icon, config) {
        console.log('[google maps] initialized..');

        if (el) {
            const longitude = parseFloat(el.data('lng')) || -1;
            const latitude = parseFloat(el.data('lat')) || -1;
            const latLng = new google.maps.LatLng(latitude, longitude);
            const svgIcon = [
                '<?xml version="1.0" encoding="UTF-8"?>',
                '<svg width="30px" height="44px" viewBox="0 0 30 44" version="1.1" xmlns="http://www.w3.org/2000/svg">',
                '<path d="M15,44 C15,44 0,23.4783068 0,15.125 C0,6.77169316 6.71572875,0 15,0 C23.2842712,0 30,6.77169316 30,15.125 C30,23.4783068 15,44 15,44 Z M15,20 C17.7614237,20 20,17.7614237 20,15 C20,12.2385763 17.7614237,10 15,10 C12.2385763,10 10,12.2385763 10,15 C10,17.7614237 12.2385763,20 15,20 Z" id="Combined-Shape"></path>',
                '</svg>'
            ].join('\n');

            this.setConfig(config || {
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                center: latLng,
                zoom: 17
            });

            const map = new google.maps.Map(el[0], maps.config);

            const marker = new google.maps.Marker({ /* eslint-disable-line */
                position: latLng,
                map: map,
                title: el.parent().parent().parent().parent().find('h1.title').html(),
                icon: icon || {
                    url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svgIcon),
                    scaledSize: new google.maps.Size(30, 44)
                },
                optimized: false
            });
        }
    },

    setConfig: function (cnf) {
        _merge(this.config, cnf);
    }
};

/**
 * Return an array of previously populated objects by key from the datalayer
 * @param  {Array} dataLayer
 * @param  {String} key Data layer keys like products|cart etc.
 * @return {Array}
 */
function getObject(dataLayer, key) {
    if (!dataLayer) {
        return null;
    }

    const dataLayerArr = dataLayer.filter(function (layer) {
        return !(typeof layer['' + key] === 'undefined' || layer['' + key] === null);
    });

    if (!dataLayerArr) {
        return null;
    }

    const dataLayerObj = dataLayerArr.map(function (element) {
        return element['' + key];
    });

    return _flatten(dataLayerObj);
}

/**
 * Bind banner impressions to the trackable banners and push the ones in view
 */
function bindBannerImpressions() {
    const philosophyBanners = $('.philosophy-slot-holder > .search-grid-asset');
    const visibleBanners = [];
    philosophyBanners.each(function (index, element) {
        const internalPromotionElement = $(element).find('[data-internal-promotion]:not([data-is-pushed])');
        const isBannerVisible = isInViewport(element);
        if (isBannerVisible && internalPromotionElement.length > 0) {
            visibleBanners.push(internalPromotionElement);
        }
    });
    const bannersToTrack = $('[data-internal-promotion]:not([data-is-pushed])');
    bannersToTrack.each(function (index, element) {
        const isBannerVisible = isInViewport(element);
        const isPhilosophyBanner = $(element).parents('.philosophy-slot-holder').length != 0;
        if (isBannerVisible && !isPhilosophyBanner) {
            visibleBanners.push(element);
        }
    });
}

/**
 * If there are trackable banners, track them on scroll
 */
function initBannerTrackingEvents() {
    // init banner tracking only if there are banenrs to track
    if ($('[data-internal-promotion]:not([data-is-pushed])').length > 0) {
        $(document).scroll(function () {
            bindBannerImpressions();
        });
    }
}

/**
 * Event to handle impression clicks
 */
function bindInternalPromotionClicks() {
    const title = $('.heading-h1');
    // handle clicks
    $('[data-internal-promotion]').on('click', function (e) {
        e.preventDefault();
        const that = this;
        const internalPromotion = $(that).data('internal-promotion').toLowerCase();

        pushDataLayerEvent({
            'event': 'faq_interaction',
            'interaction_type': 'click',
            'click_target': internalPromotion,
            'faq_category': title && title[0] ? title[0].innerText.toLowerCase() : ''
        });

        if (!that.href) {
            return;
        }
        if (that.target == '_blank') {
            window.open(that.href);
            return;
        }
        window.location = that.href;
    });
}

function bindProductSliderCtaClick() {
    $('[data-product-slider-cta]').on('click', function (e) {
        e.preventDefault();
        const that = this;
        const data = $(that).data('product-slider-cta');
        data.eventTimeout = 2000;
        data.eventCallback = function () {
            if (!that.href) {
                return;
            }
            if (that.target == '_blank') {
                window.open(that.href);
                return;
            }
            window.location = that.href;
        };
        pushDataLayerEvent(data);
    });
}

function bindNewsletterSubscribe() {
    const hideNewsletterCookie = getCookie('_hideNewsletterBlock');
    if ($('.newsletter-subscription-confirmation').length > 0 && hideNewsletterCookie) {
        pushDataLayerEvent({
            event: 'newsletter_subscription',
            click_target: 'subscribe'
        });
    }
}

/**
 * Event to handle checkout forms clicks
 */
function pushCheckoutImpressions() {
    const shippingForm = $('form[id$="_singleshipping_shippingAddress"]');
    shippingForm.on('focusout', 'input,select', function (e) {
        if (!e.originalEvent) {
            return;
        }

        const numberOfFormField = shippingForm.find(':input').index($(this)) + 1; // starts from zero
        let nameOfFormField = '';

        const $inputEl = $(this).hasClass('selectric-input') ? $(this).closest('.selectric-wrapper').find('select') : $(this);

        if ($inputEl.attr('name')) {
            const fieldName = $inputEl.attr('name').split('_');
            if (fieldName.length > 0) {
                nameOfFormField = fieldName[1] + ' ' + fieldName.pop();
            }
        }
        sendCheckoutImp(numberOfFormField, nameOfFormField);
    });

    const $purchaseDataElement = $('#purchase-gtm-data');
    if ($purchaseDataElement.length > 0 && $($purchaseDataElement).val()) {
        pushDataLayerEvent(JSON.parse($($purchaseDataElement).val()));
    }
}


function sendCheckoutImp(numberOfFormField, nameOfFormField) {
    const eventLabel = numberOfFormField + ':' + nameOfFormField;
    pushDataLayerEvent({
        'event': 'checkoutFormAnalysis',
        'eventCategory': 'form analysis',
        'eventAction': 'checkout details',
        'eventLabel': eventLabel
    });
}


function bindMenuItemClick() {
    $('.js-nav-desktop-main-list').on('click', handleMenuItemClick);
    $('.js-nav-mobile-main-list').on('click', handleMenuItemClick);
    $('.js-nav-mobile-main-list').on('touchend', handleMenuItemClick);

    function handleMenuItemClick(e) {
        const target = $(e.target);

        if (!isMenuItem(target)) {
            return '';
        }

        const categoryData = getCategoryData(target);
        if (!categoryData) {
            return;
        }

        const menuCta = getMenuCta(target);

        const isImage = target.attr('data-src');


        pushMenuItemClick(categoryData, menuCta, isImage);
    }

    function isMenuItem(target) {
        const menuCtaSelectors = '[data-menu-cta], [data-menu-cta] *';
        const categoryPathSelectors = '.js-gtm-menu-item, .js-gtm-menu-item *';

        return target.is(categoryPathSelectors) || target.is(menuCtaSelectors);
    }

    function getCategoryData(target) {
        const categoryData = target.closest('[data-analytics]');
        if (!categoryData) {
            return '';
        }

        return categoryData.data('analytics');
    }

    function getMenuCta(target) {
        const menuCtaSelectors = '[data-menu-cta], [data-menu-cta] *';
        if (target.is(menuCtaSelectors)) {
            return target.closest('[data-menu-cta]').data('menuCta');
        }

        return '';
    }

    function pushMenuItemClick(categoryData, menuCta, isImage) {
        const event = {
            event: 'menu_navigation',
            menu: 'header',
            menu_path: categoryData.categoryPath ? categoryData.categoryPath.toLowerCase().replace(/\//g, ',') : 'null',
            menu_text: categoryData.displayNameEn ? categoryData.displayNameEn.toLowerCase() : 'null',
            menu_click: isImage ? 'picture' : 'text'
        };
        if (menuCta) {
            event.cta = menuCta;
        }

        pushDataLayerEvent(event);
    }

    $('.js-nav-toggle .icon-close').on('touchend', function () {
        if (isAnalyticsDisabled()) {
            return;
        }

        const selectedCategory = $('.js-nav-mobile-main-list').find('.js-selected-category');
        if (!selectedCategory || !selectedCategory.length) {
            return;
        }

        selectedCategory.removeClass('js-selected-category');

        const categoryData = getCategoryData(selectedCategory.last());
        if (!categoryData) {
            return;
        }

        const menuCta = $(this).data('menuCta');

        pushMenuItemClick(categoryData, menuCta);
    });
}

function bindGreenFridayClick() {
    $('.js-desktop-shop-the-boxes').on('click', handleGreenFridayClick);
    $('.js-mobile-shop-the-boxes').on('touchend', handleGreenFridayClick);
    $('.js-desktop-shop-this-box').on('click', handleGreenFridayClick);
    $('.js-mobile-shop-this-box').on('touchend', handleGreenFridayClick);

    function handleGreenFridayClick(e) {
        if (isAnalyticsDisabled()) {
            return;
        }

        let action;
        let productName;

        if ($(e.target).hasClass('js-desktop-shop-the-boxes') || $(e.target).hasClass('.js-mobile-shop-the-boxes')) {
            action = 'shop the boxes';
            productName = '';
        } else {
            action = 'shop this box';
            productName = $(e.target).closest('div').children('h2').text();
        }

        const event = {
            event: 'green_friday',
            event_category: 'homepage', /* eslint-disable-line camelcase */
            event_action: action, /* eslint-disable-line camelcase */
            event_label: productName /* eslint-disable-line camelcase */
        };

        pushDataLayerEvent(event);
    }
}

function isAnalyticsDisabled() {
    return typeof (ga) === 'undefined' || !window.ga || !ga.create; /* eslint-disable-line */ //If analytics have been disabled, let the normal click handler take over
}

function pushInStoreAvailability() {
    // handle clicks
    $(document).on('click', '.js-check-instore-availabilty', function () {
        pushDataLayerEvent({
            'event': 'interaction',
            'interaction_type': 'click',
            'content_name': 'ropo',
            'click_target': 'check instore availability'
        });
    });
}

function pushInStoreAvailabilityCurrentLocation() {
    // handle clicks
    $('.js-check-instore-availabilty-current-location').on('click', function () {
        pushDataLayerEvent({
            'event': 'interaction',
            'interaction_type': 'input',
            'content_name': 'ropo',
            'click_target': 'use current location',
        });
    });
}

$('#btn-login').on('click', function () {
    setTimeout(function () {
        const existErrorForm = $('.error-text').length;
        if (existErrorForm > 0) {
            pushDataLayerEvent({
                'event': 'form_field_error',
                'error_type': 'server_error',
                'error_message': 'page_not_found',
                'error_code': '404',
                'content_name': 'login'
            });
        }
    }, 2000);
});

function bindLoginFormForgotPassword() {
    $('.js-password-reset-dialog').on('click', function () {
        pushDataLayerEvent({
            'event': 'forgotPassword',
            'eventCategory': 'login',
            'eventAction': 'password forgotten',
            'eventLabel': 'used'
        });
    });
}

function bindLearnMoreClick() {
    $('body').on('click', '.js-go-to-description', function () {
        pushDataLayerEvent({
            'event': 'croAnalysis',
            'eventCategory': 'checkout CRO',
            'eventAction': 'click on discover more',
            'eventLabel': $('.product-name').length > 0 ? $('.product-name')[0].innerHTML : ''
        });
    });
}

function bindProductDescriptionClick() {
    $('body').on('click', '.js-product-description-section', function () {
        const isSectionOpen = !($(this).attr('aria-selected') == 'true');
        pushDataLayerEvent({
            'event': 'croAnalysis',
            'eventCategory': 'checkout CRO',
            'eventAction': isSectionOpen ? 'hide product information' : 'show product information',
            'eventLabel': $('.product-name').length > 0 ? $('.product-name')[0].innerHTML : ''
        });
    });
}

function bindCOPFilterEvents() {
    const GA4_FILTER_TYPES = [
        { id: 'ritual', name: 'collection' },
        { id: 'productType', name: 'product' },
        { id: 'range', name: 'range' },
        { id: 'colorGroupHoR', name: 'colour' },
        { id: 'duration', name: 'duration' }
    ];
    let timer;
    let filterSelection = [];

    $(document).on('filterChange', function (e, lastSelectedFilter) {
        if (timer) {
            window.clearTimeout(timer);
        }

        const filterAction = lastSelectedFilter.is(':checked') ? 'added' : 'remove';

        timer = window.setTimeout(function () {
            const attributeId = lastSelectedFilter.data('attribute-id') || lastSelectedFilter.data('refinement-attribute');
            const isNewGTMFilterType = GA4_FILTER_TYPES.some(({ id }) => id === attributeId);

            if (isNewGTMFilterType) {
                const selectedFilter = lastSelectedFilter.data('filter-name') || lastSelectedFilter.data('refinement-value');

                const countElement = $('.js-search-result-count');
                const filterResults = countElement.data('count');
                countElement.remove();

                filterSelection = findActiveFilters();
                const formatedActiveFilter = formatGtmValue(selectedFilter);

                pushFilterData(formatedActiveFilter, filterAction, filterResults);
            }
        }, 400);

        //manual trigger setup
        const currentUrl = window.location.href;

        const localeMatch = currentUrl.match(/\/([a-z]{2,3}-[a-z]{2,3})\//i);
        const locale = localeMatch ? localeMatch[1].replace('-', '') : null;

        const afterLocaleMatch = currentUrl.match(/\/[a-z]{2,3}-[a-z]{2,3}\/([^/]+)/i);
        const afterLocale = afterLocaleMatch ? afterLocaleMatch[1] : null;

        if (filterAction === 'added') {
            setTimeout(() => {
                const triggerName = `filter ${locale} ${afterLocale} cop desk`;
                console.log('trigger name: ');
                console.log(triggerName);
                window.usabilla_live('trigger', triggerName);
            }, 15000);
        }
    });

    $('body').on('click', '.js-filter-by-container .js-clear-all-btn', function () {
        if (timer) {
            window.clearTimeout(timer);
        }
        if (filterSelection && filterSelection.length > 0) {
            timer = window.setTimeout(function () {
                pushFilterData(null, 'clear', null);
                filterSelection = [];
            }, 400);
        }
    });

    function findActiveFilters() {
        const filterCollection = [];

        GA4_FILTER_TYPES.map(({ id, name }) => {
            const selectedFiltersByType = $('.js-filter-options-container[data-filter-type="' + id + '"] input[type="checkbox"]:checked');
            const filtersByType = selectedFiltersByType.get().map((filter) =>
                formatGtmValue(filter.getAttribute('data-filter-name'))
            );

            if (filtersByType.length) {
                filterCollection.push({ [name]: filtersByType });
            }
        });

        return filterCollection;
    }

    function pushFilterData(filterActionValue, filterAction, filterResults) {
        pushDataLayerEvent({
            'event': 'filter',
            'filter_selection': filterSelection,
            'filter_action': filterAction,
            'filter_action_value': filterActionValue,
            'filter_results': filterResults,
            'filter_type': 'product_list'
        });
    }
}

function formatGtmValue(value) {
    return value.toLowerCase().replace(/\s+/g, '_');
}

function bindPackshotProductEvents() {
    $('body').on('click', '.js-packshot-products svg g[id*="product-id"]', function () {
        const productId = $(this).attr('id').split('-')[2];
        const productCollectionName = $('#productCollectionName').val();

        ajax.load({
            type: 'GET',
            url: Urls.getProductData,
            data: { productId: productId },
            callback: function (productData) {
                const product = JSON.parse(productData);

                if (product) {
                    pushDataLayerEvent({
                        'event': 'collectionProductInfo',
                        'eventCategory': 'collection product info',
                        'eventAction': productCollectionName,
                        'eventLabel': product.name
                    });
                }
            }
        });
    });
}

/**
 * Pushes a "view_search_results" event to the GTM data layer, when the user ends on search page.
 * Information is sent depended on the search phrase or suggestion click was applayed for search.
**/

function pushViewSearchResult() {
    $(document).ready(function () {
        const searchPhrase = $('#pageSearchPhrase');
        const category = $('#pageCategory');

        if (searchPhrase.length || category.length) {
            const searchTerm = searchPhrase.val() || category.data('category-name');
            const searchType = searchPhrase.val() ? 'input' : 'suggestion';
            const amountOfSearchResult = searchPhrase.data('products-count') || category.data('products-count');

            pushDataLayerEvent({
                'event': 'view_search_results',
                'search_term': formatGtmValue(searchTerm),
                'search_type': searchType,
                'amount_of_search_result': amountOfSearchResult
            });
        }
    });
}

/**
 * Pushes a "gwp_signup_click" event to the GTM data layer,
 * when user clicks GWP login button on cart page.
**/

function pushGwpSignupClick() {
    $('.js-gwp-login').on('click', function () {
        pushDataLayerEvent({
            'event': 'gwp_signup_click',
            'click_target': 'login'
        });
    });
}

const tagManager = {
    /**
     * Push adding and removing of products to the datalayer
     *
     * @param {String} key products|cart|search etc
     * @param {String} productId the product id
     * @param {Number} qty the quantity of how many products are effected
     * @param {String} eventName addToCartFromProduct|addToCartFromCategory|addToCartFromProductPackshot
     */
    updateQuantity: function (eventName, dataLayerProduct, qty, productPosition) {
        if (!dataLayerProduct || !eventName) {
            return false;
        }
        if (productPosition && productPosition > 1 && dataLayerProduct.items) {
            dataLayerProduct.items.forEach((item) => {
                item.position = productPosition;
            });
        }
        dataLayerProduct.event = eventName;
        pushDataLayerEvent(dataLayerProduct);
        return true;
    },

    selectVariant: function (key, masterId, variantId, availability) {
        const clone = function clone(obj) {
            return JSON.parse(JSON.stringify(obj));
        };

        const products = getObject(dataLayer, key);

        if (!products) {
            return false;
        }

        // get previously populated objects from the layer
        const selectedProducts = products.filter(function (product) {
            return ((product.sku === masterId) || (product.selectedVariant && product.selectedVariant[0].sku === variantId));
        });

        if (!selectedProducts || selectedProducts.length === 0) {
            return false;
        }

        const product = clone(selectedProducts[0]);
        product.selectedVariant = [{
            'sku': variantId,
            'name': product.name,
            'price': product.price,
            'discount': product.discount,
            'availability': availability
        }];

        pushDataLayerEvent({
            'event': 'selectedVariant',
            'products': [product]
        });

        return true;
    },

    pushVirtualPage: function (url, title, pageCategory) {
        pushDataLayerEvent({
            'event': 'VirtualPageview',
            'virtualPageURL': url,
            'virtualPageTitle': title,
            'page.category': pageCategory
        });
    },

    pushInStoreAvailabilityAddressFill: function () {
        pushDataLayerEvent({
            'event': 'interaction',
            'interaction_type': 'input',
            'content_name': 'ropo',
            'click_target': 'address input'
        });
    },

    bindFormFieldErrorEvents: function () {
        $('form input[type=text], form input[type=email], form input[type=password]').blur(function () {

            if ($(this).data('prevent-automatic-validation')) {
                return;
            }

            if ($(this).valid() == false) {
                pushDataLayerEvent({
                    'event': 'form_field_error',
                    'error_type': 'form_field_error',
                    'error_message': `wrong ${getFormFieldName(this.id)}, please enter a valid value`,
                    'error_code': null,
                    'content_name': $(this).closest('.js-create-account-left-content') && 'register page'
                });
            }
        });
    },

    pushCheckoutEditOrderSummaryEvent: function () {
        pushDataLayerEvent({
            'event': 'editOrderSummary',
            'eventCategory': 'checkout',
            'eventAction': 'event',
            'eventLabel': 'edit order summary'
        });
    },

    pushCheckoutDeliveryAddressChangeEvent: function () {
        pushDataLayerEvent({
            'event': 'deliveryAddressChange',
            'eventCategory': 'checkout',
            'eventAction': 'event',
            'eventLabel': 'change delivery address'
        });
    },

    pushCheckoutAddressDetailsChangeEvent: function () {
        pushDataLayerEvent({
            'event': 'addressDetailsChange',
            'eventCategory': 'checkout',
            'eventAction': 'event',
            'eventLabel': 'change address details'
        });
    },

    pushCheckoutBackToDetailsEvent: function () {
        pushDataLayerEvent({
            'event': 'backToDetails',
            'eventCategory': 'checkout',
            'eventAction': 'event',
            'eventLabel': 'clicked back to details'
        });
    },

    pushCheckoutPaymentMethodEvent: function (paymentMethod, bank) {
        pushDataLayerEvent({
            'event': 'paymentMethod',
            'eventCategory': 'payment method',
            'eventAction': paymentMethod,
            'eventLabel': bank
        });
    },

    pushAddCouponValid: function (couponCode) {
        pushDataLayerEvent({
            'event': 'couponCodeAdded',
            'eventCategory': 'coupon',
            'eventAction': 'used',
            'eventLabel': couponCode
        });
    },

    pushQuantityChange: function (isAdded, productID) {
        pushDataLayerEvent({
            'event': 'cartItemChanged',
            'eventCategory': 'changed cart item amount',
            'eventAction': (isAdded ? 'PLUS' : 'MINUS'),
            'eventLabel': productID
        });
    },

    pushGiftWrap: function (isTogether, isWithMessage) {
        pushDataLayerEvent({
            'event': 'giftWrap',
            'eventCategory': 'personal message gift wrap',
            'eventAction': isTogether ? 'products together' : 'products individually',
            'eventLabel': isWithMessage ? 'with message' : 'without message'
        });
    },

    pushLocalePopupChosen: function (chosenLocale) {
        const localeCurrent = $('#js-locale-in-URL').val();
        const localeSuggested = $('#js-locale-in-Cookie').val();
        pushDataLayerEvent({
            'event': 'localePopUpChoice',
            'localeChoice': chosenLocale,
            'currentLocale': localeCurrent,
            'suggestedLocale': localeSuggested
        });
    },

    pushSortingOnCategoryPage: function (sortingType) {
        const formatedSortingType = sortingType.replace(/[^-\w]+/g, '_').toLowerCase();

        pushDataLayerEvent({
            'event': 'sorting',
            'sorting_action': formatedSortingType,
        });
    },

    pushSortingOnSearchPage: function (sortingType, searchTerm) {
        pushDataLayerEvent({
            'event': 'croAnalysis',
            'eventCategory': 'checkout CRO',
            'eventAction': 'use sorting \'' + sortingType + '\' on search results page',
            'eventLabel': searchTerm
        });
    },

    pushNavigationMenuChanges: function (category) {
        pushDataLayerEvent({
            'event': 'croAnalysis',
            'eventCategory': 'checkout CRO',
            'eventAction': 'select product category',
            'eventLabel': category
        });
    },

    pushViewCartIconClick: function () {
        const cartQuantity = $('.js-shopping-circle')[0].innerText;
        const isEmpty = (!cartQuantity || cartQuantity === '0');
        pushDataLayerEvent({
            'event': 'croAnalysis',
            'eventCategory': 'checkout CRO',
            'eventAction': 'click on cart icon',
            'eventLabel': isEmpty ? 'no items in cart' : 'with items in cart'
        });
    },

    pushDeliveryMethod: function (deliveryMethod) {
        pushDataLayerEvent({
            'event': 'deliveryMethod',
            'eventCategory': 'delivery method',
            'eventAction': deliveryMethod,
            'eventLabel': 'chosen'
        });
    },

    pushCookiesAccepted: function () {
        dataLayer.push({
            'event': 'cookiesAccepted'
        });
    },

    pushCookiesDeclined: function () {
        dataLayer.push({
            'event': 'cookiesDeclined'
        });
    },

    pushProducts: function (products) {
        if (!('products' in products) && !('ecommerce' in products)) { //In case it's just a list of products, wrap it in an object
            products = {
                products: products
            };
        }

        products.event = 'trackProductImpressions'; //Ensure the event is always there

        dataLayer.push(products);
    },

    pushProductTileView: function (product) {
        product.event = 'view_item_list';
        dataLayer.push(product);
    },

    pushProductTileClick: function (product) {
        product.event = 'select_item';
        dataLayer.push(product);
    },

    pushProductTileClickNewTab: function (product) {
        dataLayer.push({
            event: 'productListClickNewTab',
            clickedProducts: [product]
        });
    },

    pushPDPTabsEvent: function (target, cssClass) {
        if (!target || !target.length) {
            return;
        }
        const analyticsData = target.closest(cssClass).data('analytics');
        if (!analyticsData) {
            return;
        }
        const analytics = JSON.parse(JSON.stringify(analyticsData));

        if (analytics.event == 'green_friday') {
            analytics.event_label = target[0].innerText.toLowerCase(); /* eslint-disable-line camelcase */
        } else if (analytics.event == 'easter') {
            analytics.event_action = target.data('tab-label'); /* eslint-disable-line camelcase */
            analytics.event_label = $('.js-the-ritual-of-title').first().text().trim(); /* eslint-disable-line camelcase */
        } else {
            analytics.content_name = decodeURI(analytics.content_name); /* eslint-disable-line camelcase */
            analytics.click_target = target[0].innerText.toLowerCase(); /* eslint-disable-line camelcase */
        }

        pushDataLayerEvent(analytics);
    },
    pushProductClickEvent: function (clickedItem, product, eventName, page) {
        pushDataLayerEvent({
            event: eventName,
            interaction: 'product click',
            click_target: clickedItem, /* eslint-disable-line camelcase */
            ecommerce: {
                click: {
                    actionField: {
                        list: page
                    },
                    products: [{
                        name: product.name,
                        id: product.id,
                        price: product.price
                    }]
                }
            }
        });
    },

    pushGwpEvent: function (action, giftType) {
        pushDataLayerEvent({
            event: 'gwp',
            gwp_action: action,
            gift_type: giftType ? giftType.toLowerCase() : null
        });
    },

    pushDataLayerEvent: pushDataLayerEvent,

    init: function () {
        bindInternalPromotionClicks();
        pushCheckoutImpressions();
        pushInStoreAvailability();
        pushInStoreAvailabilityCurrentLocation();
        bindLoginFormForgotPassword();
        bindLearnMoreClick();
        bindProductDescriptionClick();
        bindBannerImpressions();
        initBannerTrackingEvents();
        bindCOPFilterEvents();
        bindPackshotProductEvents();
        bindMenuItemClick();
        bindGreenFridayClick();
        bindNewsletterSubscribe();
        bindProductSliderCtaClick();
        if (window.location.href.includes('search')) {
            pushViewSearchResult();
        }
        pushGwpSignupClick();
    }
};

const bannerImpressions = {
    init: function () {
        bindBannerImpressions();
        initBannerTrackingEvents();
    }
};

function getFormFieldName(fieldId) {
    const checkParticleRegex = /username|password/;
    const fieldNamePosition = checkParticleRegex.test(fieldId) ? 2 : 1;

    const splits = fieldId.split('_');

    return splits[splits.length - fieldNamePosition];
}

function getFormName(fieldId) {
    const splits = fieldId.split('_');
    return splits[1];
}
// exports
exports.places = places;
exports.maps = maps;
exports.tagManager = tagManager;
exports.bannerImpressions = bannerImpressions;
exports.pushDataLayerEvent = pushDataLayerEvent;
